import { Row } from 'antd'

import SubsectionFileView from './singleView'
import SubsectionFileViewer from './viewer'
import { TApplication, TFormField } from '@/interfaces'

import { signal } from '@preact/signals-react'
import React from 'react'
import { ApplicationsState, FormState } from '@/state'

import './styles.scss'
import { FaFileCircleExclamation } from 'react-icons/fa6'

type TFileAttached = { file: string | ArrayBuffer | null; fileName: string }
export const filesAttached = signal<TFileAttached[]>([])

export default function EntityFiles({
  fileFields,
}: {
  fileFields: TFormField[]
}) {
  const hasFiles = fileFields.length > 0

  React.useEffect(() => {
    const currentEntityName = FormState.currentEntity.value?.name
    const currentApplicationValues = ApplicationsState.currentApplication.value

    let currentFilesAttached: TFileAttached[] = []

    if (hasFiles) {
      fileFields.forEach((fileInfo) => {
        const currentFileFieldName = fileInfo?.name

        if (
          currentEntityName &&
          currentApplicationValues &&
          currentFileFieldName
        ) {
          const currentEntityValues = currentApplicationValues[
            currentEntityName
          ] as TApplication

          if (currentEntityValues) {
            const currentFileValue =
              currentEntityValues[currentFileFieldName] ?? null

            ApplicationsState.currentEntityFilesData.value = {
              ...ApplicationsState.currentEntityFilesData.peek(),
              [currentFileFieldName]: currentFileValue as string,
            }

            if (currentFileValue) {
              currentFilesAttached.push({
                file: currentFileValue as string,
                fileName: fileInfo.name,
              })
            }
          }
        }
      })

      filesAttached.value = currentFilesAttached
    }
  }, [
    ApplicationsState.currentApplication.value,
    FormState.currentEntity.value,
    hasFiles,
  ])

  const isView = ApplicationsState.viewMode.value.view

  if (!hasFiles) {
    return null
  }

  if (isView && !filesAttached.value.length)
    return (
      <Row justify='start' className='subsection-files empty'>
        <div>Aún no hay archivos adjuntos para esta sección</div>
        <FaFileCircleExclamation className='empty-file-icon' />
      </Row>
    )

  return (
    <Row justify='start' className='subsection-files'>
      {fileFields.map((fileInfo) => (
        <SubsectionFileView
          key={fileInfo.name}
          fileInfo={{
            description: fileInfo.label,
            name: fileInfo.name,
            required: fileInfo.required,
          }}
        />
      ))}
      <SubsectionFileViewer />
    </Row>
  )
}
